// extracted by mini-css-extract-plugin
export default {"staticLandingPage":"static-landing-page__static-landing-page__Ey3ZJ"};